import { render, staticRenderFns } from "./reset-password.vue?vue&type=template&id=012b76c0&scoped=true&"
import script from "./reset-password.vue?vue&type=script&lang=js&"
export * from "./reset-password.vue?vue&type=script&lang=js&"
import style0 from "./reset-password.vue?vue&type=style&index=0&id=012b76c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "012b76c0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev2/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('012b76c0')) {
      api.createRecord('012b76c0', component.options)
    } else {
      api.reload('012b76c0', component.options)
    }
    module.hot.accept("./reset-password.vue?vue&type=template&id=012b76c0&scoped=true&", function () {
      api.rerender('012b76c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/auth/reset-password.vue"
export default component.exports